import { Component, Inject, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { RoutePartCMRSignatureAgents } from '@shared/src/controllers/route/cmr/RoutePartCMRSignatureAgents';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { RouteCMRAgentPhaseExpandDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentPhaseExpandDto';
import { AlertService, HString } from '@shared/src/public-api';
import { SharedExternalCMRAgentListCMRsComponent } from '../listcmrs/shared.external.cmr.agent.listcmrs.component';
import { SharedExternalCMRAgentPhaseSignActionsComponent } from './signactions/shared.external.cmr.agent.phase.signactions.component';

@Component({
    selector: 'shared-external-cmr-agent-phase',
    templateUrl: './shared.external.cmr.agent.phase.component.html',
    styleUrls: ['./shared.external.cmr.agent.phase.component.scss']
})
export class SharedExternalCMRAgentPhaseComponent implements OnInit {

    public useIonic = false;

    public phaseUUIDValue: string;
    public agentValue: RouteCMRAgents;
    public optionExpandedValue = '';

    @Output() public optionExpandedChanged = new EventEmitter<string>();

    @ViewChild(SharedExternalCMRAgentListCMRsComponent) public listECMRsComponent: SharedExternalCMRAgentListCMRsComponent;
    @ViewChild(SharedExternalCMRAgentPhaseSignActionsComponent) public signActionsComponent: SharedExternalCMRAgentPhaseSignActionsComponent;

    public value: RouteCMRAgentPhaseExpandDto;

    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {

        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    public ngOnInit(): void {
    }

    @Input()
    public set phaseUUID(value: string) {
        if (this.phaseUUIDValue === value)
            return;
        this.phaseUUIDValue = value;
        this.loadData();
    }
    public get phaseUUID(): string {
        return this.phaseUUIDValue;
    }

    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.agentValue === value)
            return;
        this.agentValue = value;
        this.loadData();
    }
    public get agent(): RouteCMRAgents {
        return this.agentValue;
    }

    @Input()
    public set optionExpanded(value: string) {
        if (this.optionExpandedValue === value)
            return;
        this.optionExpandedValue = value;
        this.optionExpandedChanged.next(this.optionExpandedValue);
    }
    public get optionExpanded(): string {
        return this.optionExpandedValue;
    }

    public get signatureAgent(): RoutePartCMRSignatureAgents {
        if (this.agent === RouteCMRAgents.driver)
            return RoutePartCMRSignatureAgents.driver;
        if (this.agent === RouteCMRAgents.sender)
            return RoutePartCMRSignatureAgents.sender;
        if (this.agent === RouteCMRAgents.consignee)
            return RoutePartCMRSignatureAgents.consignee;
        return null;
    }

    public loadData(): void {
        if (!HString.isNullOrNullString(this.phaseUUID) && RouteCMRAgentsEnum.isValid(this.agent)) {
            this.openRouteCMRController.getRouteCMRAgentPhaseByUUID(this.phaseUUID, this.agent).subscribe(data => {
                this.value = data;
            });
        }
    }

    public getCount(): number {
        if (this.value == null || this.value.cmrs == null)
            return 0;
        return this.value.cmrs.length;
    }

    public getResourcePhase(): string {
        if (this.value == null || this.value.isLoad)
            return 'SHARED.EXTERNAL.CMR.PHASE.ISLOAD';
        return 'SHARED.EXTERNAL.CMR.PHASE.ISUNLOAD';
    }

    public getResourceGoods(): string {
        if (this.getCount() === 0)
            return '';
        if (this.getCount() === 1)
            return 'SHARED.EXTERNAL.CMR.SHOWGOOD.CAPTION';
        return 'SHARED.EXTERNAL.CMR.SHOWGOODS.CAPTION';
    }

    public getResourceControlDocument(): string {
        if (this.getCount() === 0)
            return '';
        if (this.getCount() === 1)
            return 'SHARED.EXTERNAL.CMR.SHOWCONTROLDOCUMENT.CAPTION';
        return 'SHARED.EXTERNAL.CMR.SHOWCONTROLDOCUMENTS.CAPTION';
    }

    public onClickLinkOption(option: string): void {

        if (option === this.optionExpanded) {
            // Estem tancant l'opció oberta
            this.optionExpanded = '';
            return;
        }

        this.optionExpanded = option;
    }

    public onPhaseSigned(): void {
        this.loadData();
        this.collapse();
    }

    /** Formularis que s'obren des de la firma (informar d'un problema, comentar o 'estic parat') */
    public isSigningForm(): boolean {
        return this.optionExpanded === 'Incident' || this.optionExpanded === 'Comment' || this.optionExpanded === 'StandStill';
    }

    public collapse(): boolean {
        if (this.optionExpanded) {

            // Des del formulari de problema/comentari tornem a la firma, que és d'on s'ha obert
            if (this.isSigningForm()) {
                if (this.signActionsComponent != null)
                    this.signActionsComponent.loadData();
                this.optionExpanded = 'DocumentationPendingSigning';
                return true;
            }

            if (this.optionExpanded === 'ControlDocument' && this.listECMRsComponent.collapse())
                return true;

            this.optionExpanded = '';
            return true;
        }
        return false;
    }

    public pretty(value: object): string {
        return JSON.stringify(value);
    }

}
